import {URL_PARAMS_LOCAL_STORAGE_KEY, URL_PARAMS_SESSION_KEY} from 'app/utils/storage/constants';

export function getDataFromStorage(storageType: 'SESSION' | 'LOCAL'): Record<string, string> {
    let item: string | null;
    if (storageType === 'LOCAL') {
        item = window.localStorage.getItem(URL_PARAMS_LOCAL_STORAGE_KEY);
    } else {
        item = window.sessionStorage.getItem(URL_PARAMS_SESSION_KEY);
    }

    if (item && item.length > 2) {
        try {
            return JSON.parse(item);
        } catch (e) {
            console.log(e);
        }
    }
    return {};
}
